<template>
  <div class="right_block courses">
    <CourseCard v-if="isAuth && $route.name === 'course-info_id'" :course-info="courseInfo" :stages-list="stagesList" />

    <CoursesList :categories-list="categoriesList" />

    <BranchesList v-if="userRole === 'admin'" :branches-list="branchesList" />
  </div>
</template>

<script>
import CoursesList from '@/components/right_block/CoursesList'
import BranchesList from '@/components/right_block/BranchesList'
import CourseCard from '@/components/right_block/CourseCard'

export default {
  components: {
    CoursesList,
    BranchesList,
    CourseCard
  },
  props: {
    courseInfo: {
      default: () => {},
      type: Object
    },
    stagesList: {
      default: () => [],
      type: Array
    }
  },
  data() {
    return {
      currentBranchPage: 1
    }
  },
  mounted() {
    if (this.userRole === 'admin') {
      this.loadBranches()
    }
  },
  computed: {
    userRole() {
      return this.$store.state.auth.role[0]
    },
    isAuth() {
      return this.$store.state.auth.auth
    },
    branchesList() {
      return this.$store.state.right.rightBranchesList
    },
    categoriesList() {
      return this.$store.state.categories.categoriesList
    }
  },
  methods: {
    loadBranches() {
      this.$axios2
        .get('branches/simple')
        .then((resp) => {
          this.$store.commit('setRightBranchesList', { list: resp.data })
        })
        .catch(this.$errorToast)
    }
  }
}
</script>
